import dayjs from "dayjs";
import { ComponentProps } from "react";

import { omitClassNameFromProps } from "@/utils";
import { cn } from "@/utils/cn";

type TextColorLevels = 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950;
type ExpeditionDateProps = {
  date?: string | Date;
  color?: `text-${string}` | `text-${string}-${TextColorLevels}` | `text-[#${string}]`;
  slots?: {
    wrapper?: ComponentProps<"div">;
    date?: ComponentProps<"p"> & { label?: string };
    time?: ComponentProps<"p"> & { label?: string };
  };
};

export function ExpeditionDate({ date, color, slots }: ExpeditionDateProps) {
  const formattedDate = dayjs(date).format("DD/MM");
  const formattedTime = dayjs(date).format("HH:mm");

  const formattedContent = (type: "date" | "time") => {
    const isValidDate = dayjs(date).isValid();

    if (!isValidDate) {
      return "Data inválida";
    }

    if (type === "date") {
      return slots?.date?.label || formattedDate;
    }
    return slots?.time?.label || formattedTime;
  };

  return (
    <div className={cn("h-fit rounded-sm border-2 border-current text-gray-700", slots?.wrapper?.className, color)} {...omitClassNameFromProps(slots?.wrapper ?? {})}>
      <div className="bg-current px-2 py-0.5">
        <p className={cn("font-semibold text-white", slots?.date?.className)} {...omitClassNameFromProps(slots?.date ?? {})}>
          {slots?.date?.label || formattedContent("date")}
        </p>
      </div>

      <p className={cn("pb-0.5 text-center", slots?.time?.className)} {...omitClassNameFromProps(slots?.time ?? {})}>
        {slots?.time?.label || formattedContent("time")}
      </p>
    </div>
  );
}
